<template>
  <el-container style="display: block">
    <headers></headers>
    <el-container
      style="
        min-height: 1000px;

        width: 1300px;
        margin: auto;
      "
    >
      <el-aside width="205px" style="background: #fff">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-vertical-demo"
          text-color="#303133"
          active-text-color="#409EFF"
          :unique-opened="true"
          router
          ref="elMenu"
        >
          <!-- 递归动态菜单 -->
          <myitem></myitem>
        </el-menu>
      </el-aside>

      <div class="info-div">

           <div class="Main_right_bottoml">
          <div class="orderlist">
            <div class="list_title">
              <span><i class="tenant_collect"></i>我的足迹</span>
            </div>
            <div class="collect-div">

             <div class="collect-li" v-for="item in viewLsit" :key="item.index">
                            <router-link :to="'/logo/logoDetail.html?GoodsId='+item.goodsId+'&mandate='+item.mandate+'&BrandName='+item.brandName+'&slogan='+item.slogan" >
                              
                <el-image :src="item.url.replace('https://logo.aliyun.com/logo/image','https://s.zaoge.com/logo/get_alilogo.php')" alt="" srcset=""/>
              </router-link>
              </div>
            </div>
            <div class="list_con" v-show="!viewLsit">
              <div class="ordernull">
                <img src="//zuhaowan.zuhaowan.com/v1/images/null.png" />
                <p>这里空空的~您当前还没有浏览过logo哦~</p>
                <a href="/">去看看</a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </el-container>
  </el-container>
</template>

<script>
import headers from "../components/header"; // 引入头部
import myitem from "../components/myitem"; // 引入递归菜单组件
import { getApi, postApi, postApiJson } from "../../utils/request";

export default {
  data() {
    return {
      activeIndex: this.$route.path,
      viewLsit:null,
    };
  },
  created: function () {

    this.getViewList()
  },
  methods: {

    // 获取足迹列表
    getViewList() {
      postApiJson("/logoapi/logo_view_list", {
        limit:'8'
      }).then((res) => {
        console.log(res.data.success);
        if (res.data.success) {
          this.viewLsit = res.data.data;
        }
      });
    },
  },

  components: { myitem, headers },
};
</script>


<style scoped>
body {
  background-color: #f9f9f9;
}

.info-div {
  text-align: center;
  width: 100%;
  margin-left: 10px;
  background: #fff;
}

.psonCenter {
  width: 100%;
  height: 150px;
  background: #fff;
  margin-bottom: 10px;
}

.Main_right_bottoml {
  width: 659px;
  min-height: 305px;
  float: left;
}
.Main_right_bottoml {
  width: 100% !important;
}
.Main_right_bottoml .orderlist {
  background: #fff;
  padding: 15px;
  min-height: 410px;
}
.Main_right_bottoml .orderlist {
  width: 97%;
  
}
.fl {
  float: left;
}
.fr {
  float: right;
}

.Main_right_bottoml .orderlist .list_title {
  height: 42px;
  line-height: 42px;
  border-bottom: 1px solid #e9e9e9;
  position: relative;
}
.Main_right_bottoml .orderlist .list_title span {
  display: inline-block;
  font-size: 14px;
  color: #666;
  line-height: 42px;
  font-weight: bold;
}
.orderlist .list_title span {
  border-bottom: 1px solid #2196f3;
  padding: 0 10px;
  position: relative;
  float: left;
}
.Main_right_bottoml .orderlist .list_title a {
  display: inline-block;
  position: absolute;
  right: 0px;
  font-size: 12px;
  line-height: 42px;
  color: #666;
}
.Main_right_bottoml .orderlist .list_con {
  padding: 6px 0px;
}
.Main_right_bottoml .orderlist .list_con table tr td {
  padding: 13px 2px;
  border-bottom: 1px dashed #e8e8e8;
  text-align: left;
}
.Main_right_bottoml .img_tle {
  width: 70px;
}
.Main_right_bottoml .orderlist .list_con table tr td.title p.order_id {
  width: 285px !important;
}
.Main_right_bottoml .orderlist .list_con table tr p {
  font-size: 13px;
  line-height: 24px;
}
.Main_right_bottoml .orderlist .list_con table tr td.title p.serve {
  display: block;
  width: 210px;
  overflow: hidden;
  height: 25px;
}
.Main_right_bottoml .orderlist .list_con .ordernull {
  padding: 46px 15px;
  text-align: center;
}
.Main_right_bottoml .orderlist .list_con .ordernull p {
  font-size: 14px;
  color: #c1c1c1;
  line-height: 22px;
  padding: 15px 0px;
}
.Main_right_bottoml .orderlist .list_con .ordernull a {
  color: #2196f3;
  border: 1px solid #2196f3;
  border-radius: 30px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  margin-top: 2px;
}
.collect-div{
  display: grid;
  padding: 10px;
  grid-template-columns: 300px 300px 300px 300px;
  width: 100%;
}
.collect-div .collect-li{
  width: 90%;
  border: 1px dashed #999;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 10px 10px 0;
}
.collect-div .collect-li :hover{

 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.collect-div .collect-li img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/view.vue